import { PAYMENT_METHODS, type PaymentMethod } from './billing';

/** The kinds of spending a lab usually has. A lab can type its own as well. */
export const EXPENSE_CATEGORIES = [
  'Reagents and consumables',
  'Salaries',
  'Rent',
  'Electricity and utilities',
  'Equipment and repairs',
  'Transport and courier',
  'Marketing',
  'Taxes and fees',
  'Other',
] as const;

/** At most this many photos or screenshots on one expense. */
export const MAX_EXPENSE_FILES = 5;

export const EXPENSE_METHODS = PAYMENT_METHODS;
export type ExpenseMethod = PaymentMethod;

export interface ExpenseInput {
  spentOn: string;
  amountPaise: number;
  category: string;
  vendor?: string;
  method?: ExpenseMethod;
  note?: string;
  fileIds?: string[];
}

/** The reasons an expense cannot be saved, in words a person can act on. */
export function expenseProblem(e: ExpenseInput): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(e.spentOn) || Number.isNaN(Date.parse(`${e.spentOn}T00:00:00Z`)))
    return 'Choose the date it was spent.';
  if (!Number.isInteger(e.amountPaise) || e.amountPaise <= 0)
    return 'Enter an amount more than zero.';
  if (e.amountPaise > 100_000_000_00) return 'That amount is too large. Check the figure.';
  if (!e.category.trim()) return 'Choose or type a category.';
  if ((e.fileIds?.length ?? 0) > MAX_EXPENSE_FILES)
    return `Attach at most ${MAX_EXPENSE_FILES} photos.`;
  return null;
}
